/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ClientInputDto { 
    id?: number;
    name: string;
    middleName?: string | null;
    surname: string;
    emailAddress?: string | null;
    countryCode?: string | null;
    phoneNumber?: string | null;
    isActive?: boolean;
    test?: number;
}

